<template>
	<div class="login-page-container" a_id="login-page-container" extension-name="login-page">
		<div class="login-page-header" a_id="login-page-header">
			<span v-if="isTargetAgent" class="login-page-header_agent">
        {{'LoginPage.LoginHeaderStart' | translate}} <b class="login-page-header__interact login-page-header_agent">{{'LoginPage.AgentLogin' | translate}}</b>
			</span>
			<span v-else>
				{{'LoginPage.LoginHeaderStart' | translate}} <b class="login-page-header__interact">{{'LoginPage.LoginHeaderEnd' | translate}}</b>
			</span>

		</div>
		<form @submit.prevent.stop>
			<login-page-field
				input-id="account"
				a_id="login-page-field-accountId"
				v-model="accountId"
				:title="'LoginPage.AccountId' | translate"
				:placeholder="'LoginPage.AccountId' | translate"
				:disabled="accountInputDisabled"
				@enter="loginClicked"
        v-on:blur="checkIfRedirectIsNeeded"
				:show-error-message="loginFailed"
			/>

			<login-page-field
				input-id="username"
				a_id="login-page-field-userName"
				v-model="userName"
				:title="'LoginPage.UserName' | translate"
				:placeholder="'LoginPage.UserName' | translate"
				:image-type="'userName'"
				:show-error-message="loginFailed"
				@enter="loginClicked"/>

			<login-page-field
				input-id="password"
				a_id="login-page-field-password"
				v-model="password"
				:title="'LoginPage.Password' | translate"
				:type="'password'"
				:show-error-message="loginFailed"
				:error-message="this.getErrorMessage()"
				:placeholder="'LoginPage.Password' | translate"
				:image-type="'password'"
				@enter="loginClicked"/>

      <template v-for="(inp,index) in extraInputs">
        <login-page-field
            :input-id="inp.input_id"
            :a_id="inp.a_id"
            v-model="additionalFields[inp.input_id]"
            :placeholder="inp.placeholder"
            :title="inp.title"
            :type="inp.type"
            :show-error-message="loginFailed"
            :image-type="inp.image_type"
            @enter="loginClicked">
        </login-page-field>
      </template>


			<div class="login-page-footer" a_id="login-page-footer">
				<button v-if="accountId && userName && password"
						class="login-page-footer-button-right"
						@click.prevent.stop="loginClicked"
						a_id="login-page-footer-login-button">
					{{'LoginPage.LoginButton' | translate}}
				</button>
				<button v-else disabled
						class="login-page-footer-button-right"
						a_id="login-page-footer-login-button-disabled">
					{{'LoginPage.LoginButton' | translate}}
				</button>
				<a class="login-page-footer-link"
				   href="#"
				   @click="forgotPasswordClicked"
				   a_id="login-page-footer-forgot-link">
					{{'LoginPage.ForgotPasswordLink' | translate}}
				</a>
			</div>
		</form>
	</div>
</template>

<script>
	import BasePage from './BasePage.vue';
	import LoginPageField from './LoginPageField.vue';
	import LoginService from '../services/LoginService';
	import UrlService from '../../../common/services/src/url/urlService';
	import TranslateService from '../../../common/services/src/translate/translateService';
  import extensionsPlugin from '../../../common/plugins/extensionsPlugin';
  import EventBus from "../../../common/utils/events/eventBus";

	export default BasePage.extend( {
		name: "LoginSignInPage",
		props:{
			"currentAccountId" : {
				type: String,
				required: false
			}
		},
    created() {
      EventBus.$on('onRegisterExtension', this.onRegisterExtension);
      //Extensions were already loaded,
      //will add input fields here and not in onRegisterExtension
      console.log("LoginSignInPage created, triggered extension");
      this.runAddFieldsExtension();
    },
    methods: {
      runAddFieldsExtension() {
        const _this = this;
        extensionsPlugin.runExtension('add-fields', {
          addInputs(inputs) {
            console.log("Adding inputs been triggered", inputs);
            _this.extraInputs = [...inputs];
          }
        });
      },
      onRegisterExtension(name){
        console.log("LoginSignInPage onRegisterExtensionDone", name);
        if(name !== 'add-fields'){
          return;
        }
        this.runAddFieldsExtension();
      },
			forgotPasswordClicked(){
				if(!this.accountId){
					this.$emit('notify',
						this.translateService.getString('LoginPage.ForgetClickedWithoutAccountIdTitle'),
						this.translateService.getString('LoginPage.ForgetClickedWithoutAccountIdMessage'));
				} else {
					this.$emit("navigate", "ForgotPasswordPage");
				}
			},
			showError(data){
				this.loginFailed = true;

				if(data && data.message) {
					this.errorMessage = this.extractErrorMessage(data.message);
				}
				else {
					this.errorMessage = this.translateService.getString("LoginPage.GeneralError");
				}
			},
			getErrorMessage(){
				if(this.errorMessage){
					return this.errorMessage;
				}

				return TranslateService.getString("LoginPage.InvalidPasswordErrorMessage");
			},
      checkIfRedirectIsNeeded() {
        if (this.accountId) {
          LoginService.validateAuth0Account('loginapplicationkey', this.accountId).then(
              (res) => {
                if (res.data) { //In case it's an auth0 tenant
                  LoginService.redirectToAuth0LoginPage(this.accountId);
                }
              },(err) => {
            this.showError(err.data);
          })
        }
      },
			loginClicked(){
				if( !this.accountId || !this.userName || !this.password){
					return;
				}
        const _this = this;

				var authContext = {
          getFieldsInputs() {
            return {
              "accountId": _this.accountId,
              "userName": _this.userName,
              "additionalFields": _this.additionalFields
            }
          },
          setExtensionRedirect(status){
            console.log("LoginSignInPage setExtensionRedirect", status);
            _this.extensionRedirect = status;
          },
          redirect(){
            LoginService.redirectToApp();
          },
          getLoginService(){
            return LoginService;
          },
          showError(data){
            _this.showError(data);
          }
        };

        //add extension functionality after the login been authorized
        extensionsPlugin.runExtension('onLoginClick_beforeAuth', authContext);
				LoginService.auth(this.accountId, this.userName, this.password, 'loginapplicationkey', this.additionalFields).then(
					(res) => {
						if (!LoginService.isAuthorized(res.data.roles)) {
							this.loginFailed = true;
							this.errorMessage = this.translateService.getString('LoginPage.AgentAppLoginError');
							return;
						}
						this.loginFailed = false;
						LoginService.keepLoginInfo(this.userName, this.accountId);
						if(!res.data.mfa){
							this.$emit("navigate", "LoginMFAPage");
							return;
						}

						// set the Cookies && Local/Session storage(will be used by all the Apps)
						LoginService.updateLoginData(res.data["Access-Token"], res.data.userId, res.data["roles"]);
            //add extension functionality after the login been authorized
            extensionsPlugin.runExtension('onLoginClick_afterAuth', authContext);

            if(!this.extensionRedirect){
              LoginService.redirectToApp();
              return;
            }
					},
					(err) => {
						this.showError(err.data);
					}
				);
			},
		},
		data(){
			return {
				accountId: '',
				userName: '',
				password: '',
        additionalFields: {},
				loginFailed: false,
				accountInputDisabled: false,
				errorMessage: '',
				isTargetAgent: LoginService.isTargetAgentApp(),
        extraInputs: [],
        extensionRedirect: false
			};
		},
		watch: {
			accountId(){
				this.$emit('accountChanged', this.accountId)
			}
		},
		components: {
			LoginPageField
		},
		model: {
			// Parent can use "v-model" (by default, the expected event's name is "input")
			event: "navigate"
		},
		mounted(){
			let accountId = UrlService.getSearchParam('accountId');
			if(accountId) {
				this.accountId = accountId;
				this.accountInputDisabled = true;
			}
		},

	});

</script>

<style lang="scss">
	@import '../sass/loginPage.scss';

</style>



// WEBPACK FOOTER //
// src/app/LoginSignInPage.vue